export const normalizeAccountType = (accountType) => String(accountType || '').toLowerCase();

export const isFreeOrStudentPlan = (accountType) => ['free', 'student'].includes(normalizeAccountType(accountType));

// Free only - unlike isFreeOrStudentPlan, Student is a paid plan and must not be treated as Free here.
export const isFreePlan = (accountType) => normalizeAccountType(accountType) === 'free';

export const isProfessionalPlan = (accountType) => normalizeAccountType(accountType) === 'professional';

export const canUseClinicLogo = (accountType) =>
    ['clinic', 'clinic-multiuser'].includes(normalizeAccountType(accountType));

// A content item is padlocked only when the CMS marked it freemium: false AND the viewer is on
// the Free plan specifically - Student and paid plans always see padlocked content unlocked.
export const isPadlockedForUser = (item, accountType) => item?.freemium === false && isFreePlan(accountType);

// Handout bundle is a Clinic feature, but Free/Student users should first be prompted to upgrade to Pro.
export const getHandoutBundleUpgradeTarget = (accountType) => {
    if (isFreeOrStudentPlan(accountType)) return 'professional';
    if (isProfessionalPlan(accountType)) return 'clinic';
    return null;
};
